export default "__VITE_ASSET__WY2oqisrzO4DrVW9CYNGXg__ 480w, __VITE_ASSET__L8nBpPxJiAolfp13rurrxg__ 745w";